export default __webpack_public_path__ + "static/media/genre.e86203ed.png";